import { FC } from 'react';
import { Icon, BodyText, Button } from '@servicetitan/design-system';

export const GlobalSearchMFEErrorFallback: FC = () => {
    return (
        <div className="d-f align-items-center w-100 h-100 bg-orange-100 border-radius-2 flex-row p-x-1 justify-content-between">
            <span className="d-f gap-1 flex-row align-items-center">
                <Icon size="16px" name="warning" className="p-x-half" color="#FFBE00" />
                <BodyText bold size="small">
                    Refresh the page to load Search
                </BodyText>
            </span>
            <Button
                size="xsmall"
                fill="subtle"
                color="blue"
                iconName="refresh"
                onClick={() => window.location.reload()}
                className="p-0 h-100"
            >
                Refresh Page
            </Button>
        </div>
    );
};
